<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>
    <div
      :class="[{ 'p-input-icon-right': iconClass }, divclass, 'p-inputgroup']"
    >
      <i :class="iconClass" />
      <InputText
        :type="type"
        :id="id"
        ref="inputField"
        :readonly="readonly"
        :disabled="disabled"
        :placeholder="placeholder"
        :autofocus="autofocus"
        :class="[
          { 'p-invalid': typeof validate !== 'undefined' && validate.$error },
          inputClass,
          'form-control',
        ]"
        @keydown.enter="$emit('keydown-enter')"
        :value="colorHashValue"
      />
      <ColorPicker
        :defaultColor="defaultColor"
        :format="format"
        v-model="inputValue"
      />
    </div>
    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
      :baseErrorClass="baseErrorClass"
    />
  </div>
</template>

<script>
import InputText from "primevue/inputtext";
import ColorPicker from "primevue/colorpicker";
export default {
  inheritAttrs: false,
  components: {
    InputText,
    ColorPicker,
  },
  props: {
    defaultColor: {
      type: String,
      default: "ff0000",
    },
    format: {
      type: String,
      default: "hex",
    },
    autofocus: {
      type: Boolean,
      required: false,
    },
    id: {
      type: String,
      default: "",
    },
    label: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    type: {
      type: String,
      default: "text",
      validator: function (value) {
        // The value must match one of these strings
        return ["text", "password", "number"].indexOf(value) !== -1;
      },
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    placeholder: {
      type: String,
      default: "",
    },
    readonly: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    iconClass: {
      type: String,
    },
    inputClass: {
      type: String,
      required: false,
    },
    divclass: {
      type: String,
      default: "",
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
    baseErrorClass: {
      type: String,
      required: false,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      // setter
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
    colorHashValue: {
      get: function () {
        return this.value.indexOf("#") > -1 ? this.value : "#" + this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
